import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

export type TypeParams = ec.models.TypeParams.WithDefaults<{
  entity: Entity
  context: Context
}>

export type Entity = Pick<ents.core.mosaic.Page, 'id' | 'name'>
export type Context = ents.core.admin.Context.ForZone | undefined

/** Distinguishes page selection when creating new app page within app builder from other page selection contexts. */
export const SELECTION_TARGET: ec.models.Target = 'app-builder-page-selection'
